import { Button, Shimmer } from '@components/atoms'
import { MonitorContext } from '../../context'
import { Stack, Typography } from '@mui/material'
import { ArrowForwardIos } from '@mui/icons-material'
import { useContextSelector } from 'use-context-selector'
import { isMobile } from 'react-device-detect'
import { Actions } from '../Actions'
import { useParams, useNavigate } from 'react-router-dom'
import { useCallback } from 'react'
import UserGroupIcon from '@assets/icons/user-group.svg'

import {
  NavLink,
  TextLink,
  Container,
  ContentPaths,
  LeftSide,
  RightSide,
} from './styles'


export default function Header() {
  const { id } = useParams()
  const navigate = useNavigate()
  const handleMonitorMembers = useCallback(() => {
    navigate(`/monitors/${id}/users`)
  }, [id])
  const { data: monitor, isLoading } = useContextSelector(MonitorContext, (s) => s.monitor)

  return (
    <Container>
      <LeftSide>
        <ContentPaths>
          <NavLink to="/monitors">
            <TextLink variant="$font-body-base">Monitoramento</TextLink>
          </NavLink>
          <ArrowForwardIos sx={{ fontSize: '10px', color: '#B2BBBF' }} />
          <Typography variant="$font-body-base" color="$color-text-primary">
            Painel
          </Typography>
        </ContentPaths>

        <Stack direction="row">
          <Shimmer isLoading={isLoading} width={240}>
            <Typography variant="$font-title-1" color="$color-text-primary">
              {monitor?.name || '--'}
            </Typography>
          </Shimmer>
        </Stack>
      </LeftSide>

      <RightSide>
        <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="space-between"
          >
            {!isMobile && (
              <Button
                id="users-page-link"
                size="medium"
                variant="text"
                text="Membros"
                sx={{ px: 2 }}
                onClick={handleMonitorMembers}
                startIcon={<img src={UserGroupIcon} alt="Membros" />}
              />
            )}
            <Actions />
          </Stack>
      </RightSide>
    </Container>
  )
}
